// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React from 'react';
import S from './styles';

const Tooltip = (props: React.ComponentPropsWithRef<'div'>): JSX.Element => {
  const { children } = props;
  return (
    <S.Container {...props}>
      <S.TooltipWrapper>
        <S.Text>{children}</S.Text>
        <S.ArrowDown />
      </S.TooltipWrapper>
    </S.Container>
  );
}

export { Tooltip as default };
